import { api } from "@/lib/api";

export const ASSIGNMENT_FILE_ACCEPT = ".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg";
const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "txt", "png", "jpg", "jpeg"];
const MAX_BYTES = 10 * 1024 * 1024;

export function assignmentFileError(file) {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (!ALLOWED_EXTENSIONS.includes(extension)) return `${file.name}: unsupported file type`;
  if (file.size > MAX_BYTES) return `${file.name}: file must be 10 MB or smaller`;
  if (!file.size) return `${file.name}: file is empty`;
  return "";
}

export async function uploadAssignmentFiles(assignmentId, category, files) {
  if (!files.length) return null;
  const form = new FormData();
  files.forEach((file) => form.append("files", file));
  return api.post(`/assignments/${assignmentId}/files?category=${category}`, form);
}